module.exports = __webpack_public_path__ + "static/media/16-17.a0dd803d.mp3";